
import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";
import {DetailPage} from "../../detail-page/detail-page";


export class FoldedDocumentComponent extends DetailPage{
    controller = this.findMember("controller").val();

    ready(){
        super.ready();
        this.$root.data("controller",this.controller);
        this.$root.find(".js-folded-document__folder-toggle").on("click", (ev)=>{
            ev.preventDefault();
            let folderContent = ev.currentTarget.nextElementSibling;
            if (folderContent.style.display === "none" || folderContent.style.display === "") {
                folderContent.style.display = "block";
            } else {
                folderContent.style.display = "none";
            }
        })


        this.$root.find(".js-folded-document__toggle-folder").on("click", (ev)=>{
            ev.preventDefault();
            let folderContent = this.$root.find(this.scope+"__form-folder");
            let fileContent = this.$root.find(this.scope+"__form-file");
            if(fileContent[0].style.display !== "none"){
                fileContent.toggle();
            }
            folderContent.toggle();
        })

        this.$root.find(".js-folded-document__toggle-file").on("click", (ev)=>{
            ev.preventDefault();
            let fileContent = this.$root.find(this.scope+"__form-file");
            let folderContent = this.$root.find(this.scope+"__form-folder");
            if(folderContent[0].style.display !== "none"){
                folderContent.toggle();
            }
            fileContent.toggle();
        })


        this.$root.find(this.scope+"__add-folder").on("click", (ev)=>{
            ev.preventDefault();
            let params = {
                folderName: this.$root.find("[name=folder_name]").val(),
                folderLocation: this.$root.find("[name=folder_location]").val(),
                documentId: this.$root.find("[name=id]").val()
            }
            GvfService.endpoint(this.controller+"/addFolder",params).then((response)=>{
                if(response.success == true){
                    this.drawFolder();
                }
            })

        })

        this.$root.find(this.scope+"__add-file").on("click", (ev)=>{
            ev.preventDefault();
            let params = {
                fileIds: this.$root.find("[name=add_files]").val(),
                documentId: this.$root.find("[name=id]").val(),
                fileLocation: this.$root.find("[name=file_location]").val()
            }
            GvfService.endpoint(this.controller+"/addFilesToFolder",params).then((response)=>{
                if(response.success == true){
                    this.drawFolder();
                }
            })
        });

        this.$root.find(`${this.scope}__download-file`).on("click", (ev)=>{
            ev.preventDefault();
            let params = {
                documentId: this.$root.find("[name=id]").val(),
                fileId: $(ev.currentTarget).data('file')
            };
            GvfService.endpoint(`${this.controller}/downloadFile`,{params:params}).then((response)=>{
                if(response.success == true && response.url){
                    window.location.href = response.url;
                }
            });
        });

        this.$root.find(this.scope+"__remove-file").on("click", (ev)=>{
            ev.preventDefault();
            let params = {
                documentId: this.$root.find("[name=id]").val(),
                fileId: ev.currentTarget.getAttribute("data-file")
            }
            swal(
                { title: GvfService.lang("¡Atención! Vas a eliminar un archivo"),
                    text: GvfService.lang("esta-accion-eliminara-un-archivo-de-la-documentacion-permanente", "Esta acción eliminará un archivo de la documentación de forma definitiva, no será recuperable. ¿Está seguro?"),
                    type: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#e70101",
                    cancelButtonColor: "#184b78",
                    confirmButtonText: GvfService.lang("ELIMINAR"),
                    cancelButtonText: GvfService.lang("Esperar"),
                    closeOnConfirm: true,
                    closeOnCancel: true,
                    allowEscapeKey: false},
                (isConfirm)=>{
                    if(isConfirm){
                        GvfService.endpoint(this.controller+"/removeFile",params).then((response)=>{
                            if(response.success == true){
                                this.drawFolder();
                            }
                        })
                    }
                }
            )
        });

        this.findMember('remove-folder').on('click', (ev)=>{
            ev.preventDefault();
            let params = {
                documentId: this.$root.find("[name=id]").val(),
                folderKey: $(ev.currentTarget).data('key'),
            };
            GvfService.endpoint(this.controller+"/remove-folder",{params:params}).then(response=>{
                if(response.success == true){
                    this.drawFolder();
                }
            });
        });

        super.viewFiles('BuildingDocument');
    }

    drawFolder(){
        let params = {
            documentId: this.$root.find("[name=id]").val(),
            modelName: this.controller.split("/").pop().replace("-detail", "").replace(/-./g, (match) => match[1].toUpperCase()).replace(/^./, (match) => match.toUpperCase())
        }
        GvfService.endpoint(this.controller+"/drawFolder",params).then((resp)=>{
            let $piece = this.$root.find(".js-folded-document__folder-container");
            $piece.html(resp.html);
            this.ready();
            GvfUiService.init();
        });
    }
}

